import { IGreenCard, IPolicy } from '../models/policy'
import { BaseUrl } from './base_url_enum'
import Api, { IApiResponse } from './index'
import { IGetPoliciesResponse } from './types/policies'

export const getPolicies = (relationNumber: number) => Api<IGetPoliciesResponse>('GET', `relations/${relationNumber}/policies`, BaseUrl.Afd, undefined, true)

export const generateInsuranceCard = (refKey: string, relationNumber: number, policyNumberPullingVehicle: string, policyNumberTowedVehicle: string) =>
  Api<IApiResponse<IGreenCard>>('POST', `intermediary/${refKey}/relation/${relationNumber}/${policyNumberPullingVehicle}/${policyNumberTowedVehicle}/insurance-certificate`, BaseUrl.Request)

export const getPolicy = (id: string, relationNumber: number) => Api<IPolicy>('GET', `relations/${relationNumber}/policies/${id}`, BaseUrl.Afd)

export const requestPolicyAdvise = (
  relationNumber: string,
  agencyId: string,
  adviseExplanation: string,
  products: string[]
) =>
  Api('POST', `intermediary/${agencyId}/relation/${relationNumber}/advice-request/create`, BaseUrl.Request, {
    description: adviseExplanation,
    products: products?.filter(item => item !== '')
  })

export const postRebuildValueMeter = async (
  refKey: string,
  relationNumber: number,
  policyId: string,
  data: Record<string, unknown>
) => Api('POST', `intermediary/${refKey}/relation/${relationNumber}/policy-change/${policyId}`, BaseUrl.Request, data)

export const postContentsInsuranceValue = async (
  refKey: string,
  relationNumber: number,
  policyId: string,
  data: Record<string, unknown>
) => Api('POST', `intermediary/${refKey}/relation/${relationNumber}/policy-change/${policyId}`, BaseUrl.Request, data)

export const getCombiPolicyPdfUrl = (
  refKey: string,
  relationNumber: number
) => Api<IApiResponse<{ url: string }>>('GET', `agency/${refKey}/relations/${relationNumber}/policy-schedule-url`, BaseUrl.Afd)
